import { useTranslation } from 'react-i18next';
import {
  Action,
  ActionsTableMenu,
} from 'src/components/atoms/actions-table-menu';
import { usePermissions } from 'src/permissions/can';
import { BookingState } from '../../types/booking-state';

interface Props {
  onConfirmPresence: () => void;
  onFinish: () => void;
  onCancel: () => void;
  state: BookingState;
  confirmedAt: string | null;
}

export const BookingsActionsTableMenu = ({
  onConfirmPresence,
  onFinish,
  onCancel,
  state,
  confirmedAt,
}: Props) => {
  const { t } = useTranslation(['bookings', 'common']);

  const permissions = usePermissions();

  // Only bookings with state "Started" that have not been already confirmed can have presence confirmed
  const canConfirmPresence = state === 'STARTED' && confirmedAt === null;

  // Only bookings with state "Started" can be finished
  const canFinish = state === 'STARTED';

  // Only bookings with state "Booked" can be cancelled
  const canCancel = state === 'BOOKED';

  const actions: Action[] = [
    {
      id: 'confirm-presence',
      label: t('bookings:common.actions.confirm'),
      onClick: onConfirmPresence,
      disabled:
        permissions.cannot('confirmPresence', 'Bookings') ||
        !canConfirmPresence,
      tooltip: !canConfirmPresence
        ? t('bookings:common.confirmTooltip')
        : t('common:notSufficientPermissions'),
    },
    {
      id: 'finish',
      label: t('bookings:common.actions.finish'),
      onClick: onFinish,
      disabled: permissions.cannot('finish', 'Bookings') || !canFinish,
      tooltip: !canFinish
        ? t('bookings:common.finishTooltip')
        : t('common:notSufficientPermissions'),
    },
    {
      id: 'cancel',
      label: t('bookings:common.actions.cancel'),
      onClick: onCancel,
      disabled: permissions.cannot('cancel', 'Bookings') || !canCancel,
      tooltip: !canCancel
        ? t('bookings:common.cancelTooltip')
        : t('common:notSufficientPermissions'),
    },
  ];

  return <ActionsTableMenu actions={actions} />;
};
